import React, { useState, useEffect } from "react";
import { Timestamp } from "components/common";
import { Badge, Row } from "common/components";
import { RiskScoreBadge } from "security-app/components/common";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import {
  RowTitleButton,
  ExpandButton
} from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/column-renderers";
const TitleCell = ({
  event,
  firstEventId
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => {
    setIsOpened((prev) => !prev);
    toggleSection(event.id, "restFieldsExpandedSection");
  };
  useEffect(() => {
    if (firstEventId && event.id === firstEventId) toggleSection(event.id, "restFieldsExpandedSection");
    setIsOpened(firstEventId === event.id);
  }, [firstEventId, event.id, toggleSection]);
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "md" }, /* @__PURE__ */ React.createElement(
    ExpandButton,
    {
      name: isOpened ? "keyboard_arrow_up" : "keyboard_arrow_down",
      title: "Expand details",
      onClick: toggleExtraSection
    }
  ), /* @__PURE__ */ React.createElement(Row, { $align: "baseline" }, /* @__PURE__ */ React.createElement(RowTitleButton, null, (event == null ? void 0 : event.message) || "No title set")));
};
const EventCountCell = ({ eventCount }) => /* @__PURE__ */ React.createElement(Badge, null, eventCount);
export const columnRenderers = {
  attributes: {
    message: {
      renderCell: (_, event, { first_event_id }) => /* @__PURE__ */ React.createElement(TitleCell, { event, firstEventId: first_event_id })
    },
    event_count: {
      staticWidth: 250,
      renderCell: (_, event) => /* @__PURE__ */ React.createElement(EventCountCell, { eventCount: event.event_count })
    },
    risk_score: {
      staticWidth: 250,
      renderCell: (_, event) => /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: event.risk_score })
    },
    latest_event_at: {
      staticWidth: 250,
      renderCell: (latest_event_at) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: latest_event_at })
    },
    earliest_event_at: {
      staticWidth: 250,
      renderCell: (earliest_event_at) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: earliest_event_at })
    }
  }
};
